import React from 'react';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';

const RoadmapGoalDetailsStepLayout = () => {
  return <MetaControlField attr={'outcomes'} />;
};

export { RoadmapGoalDetailsStepLayout };
